module.exports = __webpack_public_path__ + "static/media/sia-climate.e4454333.png";